export default {
  title: {
    id: 'past_invoices_page_title',
    defaultMessage: 'All invoices',
  },
  description: {
    id: 'past_invoices_page_description',
    defaultMessage:
      'Here, you’ll find a list of all invoices, both pending and paid, for each marketplace you’re live in.',
  },
  invoiceNumberHeader: {
    id: 'past_invoices_page_table_header_invoice_number',
    defaultMessage: 'Invoice number',
  },
  salesRevenueHeader: {
    id: 'past_invoices_page_table_header_sales_revenues',
    defaultMessage: 'Sales revenue (incl. tax)',
  },
  downloadPdfLink: {
    id: 'past_invoices_page_table_download_pdf_link',
    defaultMessage: 'PDF',
  },
  downloadCsvLink: {
    id: 'past_invoices_page_table_download_csv_link',
    defaultMessage: 'CSV',
  },
  amountReceivedHeader: {
    id: 'past_invoices_page_table_header_amount_received',
    defaultMessage: 'Amount received',
  },
  currencyHeader: {
    id: 'past_invoices_page_table_header_currency',
    defaultMessage: 'Currency',
  },
  startDateHeader: {
    id: 'past_invoices_page_table_start_date',
    defaultMessage: 'Start date (incl.)',
  },
  endDateHeader: {
    id: 'past_invoices_page_table_end_date',
    defaultMessage: 'End date (incl.)',
  },
  paymentDateHeader: {
    id: 'past_invoices_page_table_payment_date',
    defaultMessage: 'Payment date',
  },
  statusHeader: {
    id: 'past_invoices_page_table_status',
    defaultMessage: 'Status',
  },
  totalHeader: {
    id: 'bo_seller.money.past_invoices.trade_in.total',
    defaultMessage: 'Total',
  },
  amountOrdersHeader: {
    id: 'bo_seller.money.past_invoices.trade_in.amount',
    defaultMessage: 'Amount',
  },
  downloadHeader: {
    id: 'past_invoices_page_table_header_download',
    defaultMessage: 'Download',
  },
  noDataSurtitle: {
    id: 'past_invoices_page_no_data_surtitle',
    defaultMessage: 'Good things come to those who wait.',
  },
  noDataTitle: {
    id: 'past_invoices_page_no_data_title',
    defaultMessage: 'You don’t have any past invoices.',
  },
  noDataDescription: {
    id: 'past_invoices_page_no_data_description',
    defaultMessage: 'Are you new here? Check back next month, eager beaver.',
  },
  pastInvoicesNavigation: {
    id: 'past_invoices_page_navigation_label',
    defaultMessage: 'Past invoices navigation',
  },
}
